import { CITIES, type CityKey } from "@/constants/cities";
import type { ListResponse } from "@/types/lists.types";

export function groupListsByCity(lists: ListResponse[]): [string, ListResponse[]][] {
  const grouped: Record<string, ListResponse[]> = {};
  for (const list of lists) {
    const key = list.city || "other";
    (grouped[key] ||= []).push(list);
  }
  return Object.entries(grouped).sort(([a], [b]) => {
    if (a === "other") return 1;
    if (b === "other") return -1;
    const nameA = CITIES[a as CityKey]?.name || a;
    const nameB = CITIES[b as CityKey]?.name || b;
    return nameB.localeCompare(nameA);
  });
}

export function cityDisplayName(key: string): string {
  return key === "other" ? "Other" : CITIES[key as CityKey]?.name || key;
}
